<template>
  <div>
    <v-layout row>
      <v-flex>
        <v-card width="100%">
          <v-card-text>
            <v-layout class="title" align-baseline>
              <v-flex xs2> {{ $t('commodityInfo') }}: </v-flex>
              <v-flex xs3>
                <v-btn
                  dark
                  color="primary"
                  @click="showCommodityEditPopup({}, 'add')"
                  v-if="!isCommodityUnchangeable"
                  >{{ $t('addCommodity') }}</v-btn
                >
              </v-flex>
              <v-flex
                class="red--text font-weight-bold text-xs-right"
                v-if="errorMessage"
              >
                {{ errorMessage }}
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="commodityHeaders"
              :items="value"
              hide-actions
              class="elevation-2 mt-2"
            >
              <template v-slot:items="props">
                <td class="subheading">
                  {{ props.item.scheduleBDescription }}
                </td>
                <td class="text-xs-left">{{ actionFrom === 'eei' ? props.item.scheduleBCode || '' : props.item.harmonizedCode || props.item.scheduleBCode }}</td>
                <td class="text-xs-left">
                  {{ props.item.exportInformationCode }}
                </td>
                <td class="text-xs-left">{{ props.item.countryOfOrigin }}</td>
                <td class="text-xs-left">
                  {{ props.item.licenseExceptionSymbol }}
                </td>
                <td class="text-xs-left">
                  ${{ props.item.customsValue.toLocaleString() }}
                </td>
                <td class="text-xs-left">{{ props.item.quantity }}</td>
                <td class="text-xs-left">{{ props.item.quantity2 }}</td>
                <td class="text-xs-left">{{ props.item.commodityWeight }}</td>
                <td
                  class="text-xs-center"
                  v-if="
                    !isCommodityUnchangeable || actionFrom === 'createLabel'
                  "
                >
                  <v-btn icon @click="showCommodityEditPopup(props, 'edit')"
                    ><v-icon>edit</v-icon></v-btn
                  >
                  <v-btn
                    icon
                    @click="deleteCommodity(props.item)"
                    v-if="!isCommodityUnchangeable"
                    ><v-icon>delete</v-icon></v-btn
                  >
                </td>
              </template>
            </v-data-table>
            <FormSubmitPopup
              :title="
                actionType === 'add' ? $t('addCommodity') : $t('editCommodity')
              "
              v-model="isShowEditCommodityPopup"
              :leftMethod="closeEditCommodityPopup"
              :rightMethod="onSubmit"
              large
            >
              <template v-slot:input>
                <template v-if="actionFrom === 'eei'">
                  <v-card-text>
                    <v-layout justify-space-between>
                      <v-flex xs4>
                        <v-select
                          style="padding-top: 24px"
                          :label="$t('commonCommodity')"
                          :items="commonCommodities"
                          item-text="description"
                          item-value="description"
                          return-object
                          v-model="commonCommodity"
                          @change="onSelectCommonCommodity"
                          v-if="
                            !(
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            )
                          "
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-menu
                          offset-y
                          :close-on-content-click="false"
                          v-model="menuProfile"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              ref="profile"
                              :label="$t('savedCommodity')"
                              persistent-hint
                              v-model="searchText"
                              @click.stop="on.click"
                              @keyup.enter="getCommodities"
                              v-if="
                                !(
                                  isCommodityUnchangeable &&
                                  actionFrom === 'createLabel'
                                )
                              "
                            >
                              <template v-slot:append>
                                <LoaderButton
                                  flat
                                  isSmall
                                  :promiseAwait="getCommodities"
                                  :buttonText="$t('search')"
                                  :disabled="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                ></LoaderButton>
                              </template>
                            </v-text-field>
                          </template>
                          <v-list
                            v-if="
                              searchedCommodities && searchedCommodities.length
                            "
                          >
                            <v-list-tile
                              v-for="item in searchedCommodities"
                              :key="item.requestId"
                              @click.stop="() => onSelectCommodity(item)"
                            >
                              <v-list-tile-content>
                                <v-list-tile-title>{{
                                  item.profileName
                                }}</v-list-tile-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-icon
                                  @click.stop="() => removeCommodityDb(item)"
                                  >delete</v-icon
                                >
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    <v-form ref="form" lazy-validation>
                      <v-layout align-baseline justify-space-between>
                        <v-flex xs2>
                          <v-text-field
                            hide-details
                            :label="$t('scheduleBDescription')"
                            :rules="[fieldIsRequired()]"
                            class="required_field"
                            v-model="commodityInEdit.scheduleBDescription"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <template v-if="isCreateFedex">
                            <v-text-field
                              hide-details
                              :label="$t('hsCode')"
                              :rules="[fieldIsRequired('hsCode')]"
                              :class="'required_field'"
                              v-model.trim="commodityInEdit.harmonizedCode"
                            ></v-text-field>
                          </template>
                          <template v-else>
                            <v-text-field
                              hide-details
                              :label="$t('scheduleBCode')"
                              :rules="[fieldIsRequired()]"
                              :class="'required_field'"
                              :disabled="!isScheduleBReady"
                              :readonly="
                                isCommodityUnchangeable &&
                                actionFrom === 'createLabel'
                              "
                              v-model="commodityInEdit.scheduleBCode"
                            ></v-text-field>
                          </template>
                        </v-flex>
                        <v-flex xs2>
                          <v-autocomplete
                            hide-details
                            v-model="commodityInEdit.exportInformationCode"
                            :items="[
                              { text: $t('osAllOtherExports'), value: 'OS' }
                            ]"
                            item-value="value"
                            item-text="text"
                            :rules="[fieldIsRequired()]"
                            class="required_field"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                            :label="$t('exportInformationCode')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs2>
                          <v-autocomplete
                            hide-details
                            :items="[
                              { text: $t('c33NoLicenseRequired'), value: 'C33' }
                            ]"
                            item-value="value"
                            item-text="text"
                            :rules="[fieldIsRequired()]"
                            class="required_field"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                            v-model="commodityInEdit.licenseExceptionSymbol"
                            :label="$t('licenseExceptionSymbol')"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout align-baseline justify-space-between>
                        <v-flex xs2>
                          <v-autocomplete
                            hide-details
                            :items="countryCodeArray"
                            item-text="name"
                            item-value="value"
                            :rules="[fieldIsRequired()]"
                            class="required_field"
                            v-model="commodityInEdit.countryOfOrigin"
                            :label="$t('countryOfOrigin')"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs2>
                          <v-text-field
                            hide-details
                            label="ECCN"
                            v-model="commodityInEdit.eccn"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-text-field
                            hide-details
                            :label="$t('totalCommodityWeight')"
                            v-model.number="commodityInEdit.commodityWeight"
                            :rules="[
                              fieldIsRequired('weight'),
                              fieldIsNoLessThanZero('weight'),
                              isMeasurementMetric
                                ? () => true
                                : fieldIsPkgWeight(false)
                            ]"
                            class="required_field"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                            :suffix="isMeasurementMetric ? 'kg' : 'Lbs'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-text-field
                            hide-details
                            class="required_field"
                            :rules="[
                              fieldIsRequired(),
                              fieldIsNoLessThanZero()
                            ]"
                            v-model.number="commodityInEdit.customsValue"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                            :label="$t('totalCustomsValue($)')"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-form>
                    <v-layout align-baseline justify-space-between>
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :rules="[
                            fieldIsRequired(),
                            fieldIsInteger(),
                            fieldIsOverZero()
                          ]"
                          class="required_field qty_unit_filed"
                          v-model.number="commodityInEdit.quantity"
                          :label="$t('quantity')"
                          :readonly="
                            isCommodityUnchangeable &&
                            actionFrom === 'createLabel'
                          "
                          :suffix="isUnitValid ? qtySuffix : ''"
                        >
                          <template slot="append-outer" v-if="!isUnitValid">
                            <v-select
                              class="qty_unit"
                              :items="inShowChannelUnionList"
                              v-model="commodityInEdit.selectedUnit"
                              hide-details
                              clearable
                              item-text="text"
                              item-value="key"
                              :label="$t('unit')"
                            ></v-select>
                          </template>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          hide-details
                          :rules="[
                            fieldIsRequired(),
                            fieldIsInteger(),
                            fieldIsOverZero()
                          ]"
                          class="required_field"
                          v-model.number="commodityInEdit.quantity2"
                          :label="$t('quantity')"
                          :readonly="
                            isCommodityUnchangeable &&
                            actionFrom === 'createLabel'
                          "
                          v-if="isShowQty2"
                          :suffix="scheduleBMap[scheduleBCodeNormalized].uom1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 style="white-space: nowrap">
                        <span v-if="!isScheduleBReady"
                          ><v-icon>info</v-icon
                          >{{ $t('loadingScheduleB') }}</span
                        >
                      </v-flex>
                      <v-flex xs2> </v-flex>
                    </v-layout>
                    <v-layout justify-end align-baseline>
                      <v-flex xs2>
                        <v-text-field
                          v-if="isSaveCommodityProfile"
                          hide-details
                          v-model.trim="commodityInEdit.profileName"
                          class="required_field"
                          :rules="[fieldIsRequired()]"
                          :label="$t('profileName')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 v-if="actionType === 'add'">
                        <v-checkbox
                          :label="$t('saveCommodityProfile')"
                          hide-details
                          class="checkbox"
                          v-model="isSaveCommodityProfile"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </template>
                <template v-else>
                  <v-card-text>
                    <v-layout justify-space-between>
                      <v-flex xs4>
                        <v-select
                          style="padding-top: 24px"
                          :label="$t('commonCommodity')"
                          :items="commonCommodities"
                          item-text="description"
                          item-value="description"
                          return-object
                          v-model="commonCommodity"
                          @change="onSelectCommonCommodity"
                          v-if="
                            !(
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            )
                          "
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-menu
                          offset-y
                          :close-on-content-click="false"
                          v-model="menuProfile"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              ref="profile"
                              :label="$t('savedCommodity')"
                              persistent-hint
                              v-model="searchText"
                              @click.stop="on.click"
                              @keyup.enter="getCommodities"
                              v-if="
                                !(
                                  isCommodityUnchangeable &&
                                  actionFrom === 'createLabel'
                                )
                              "
                            >
                              <template v-slot:append>
                                <LoaderButton
                                  flat
                                  isSmall
                                  :promiseAwait="getCommodities"
                                  :buttonText="$t('search')"
                                  :disabled="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                ></LoaderButton>
                              </template>
                            </v-text-field>
                          </template>
                          <v-list
                            v-if="
                              searchedCommodities && searchedCommodities.length
                            "
                          >
                            <v-list-tile
                              v-for="item in searchedCommodities"
                              :key="item.requestId"
                              @click.stop="() => onSelectCommodity(item)"
                            >
                              <v-list-tile-content>
                                <v-list-tile-title>{{
                                  item.profileName
                                }}</v-list-tile-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-icon
                                  @click.stop="() => removeCommodityDb(item)"
                                  >delete</v-icon
                                >
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    <v-form ref="form" lazy-validation>
                      <v-layout row wrap mb-3>
                        <v-flex xs6>
                          <v-layout row wrap>
                            <v-flex xs11 pr-3>
                              <v-text-field
                                hide-details
                                :label="$t('scheduleBDescription')"
                                :rules="[fieldIsRequired()]"
                                class="required_field"
                                v-model="commodityInEdit.scheduleBDescription"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-card raised>
                        <v-card-text>
                          <v-layout row wrap>
                            <h2>Invoice info</h2>
                          </v-layout>
                          <template v-if="isCreateUps">
                            <v-layout align-baseline justify-space-between>
                              <v-flex xs2>
                                <v-autocomplete
                                  hide-details
                                  :items="countryCodeArray"
                                  item-text="name"
                                  item-value="value"
                                  :rules="[fieldIsRequired()]"
                                  class="required_field"
                                  v-model="commodityInEdit.countryOfOrigin"
                                  :label="$t('countryOfOrigin')"
                                  :readonly="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  :label="$t('hsCode')"
                                  :rules="[fieldIsRequired($t('hsCode'))]"
                                  :class="'required_field'"
                                  v-model.trim="commodityInEdit.harmonizedCode"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  :rules="[
                                    fieldIsRequired(),
                                    fieldIsInteger(),
                                    fieldIsOverZero()
                                  ]"
                                  class="required_field qty_unit_filed"
                                  v-model.number="commodityInEdit.quantity2"
                                  :label="$t('quantity')"
                                  :suffix="
                                    isHsCodeUnitValid ? hsCodeQtySuffix : ''
                                  "
                                >
                                  <template
                                    slot="append-outer"
                                    v-if="!isHsCodeUnitValid"
                                  >
                                    <v-select
                                      class="qty_unit"
                                      :items="upsHsCodeUnionList"
                                      v-model="commodityInEdit.quantity2Units"
                                      hide-details
                                      clearable
                                      item-text="text"
                                      item-value="key"
                                      :label="$t('unit')"
                                    ></v-select>
                                  </template>
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2> </v-flex>
                            </v-layout>
                          </template>
                          <template v-else>
                            <v-layout align-baseline justify-space-between>
                            <v-flex xs2>
                              <v-autocomplete
                                hide-details
                                :items="countryCodeArray"
                                item-text="name"
                                item-value="value"
                                :rules="[fieldIsRequired()]"
                                class="required_field"
                                v-model="commodityInEdit.countryOfOrigin"
                                :label="$t('countryOfOrigin')"
                                :readonly="
                                  isCommodityUnchangeable &&
                                  actionFrom === 'createLabel'
                                "
                              ></v-autocomplete>
                            </v-flex>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  :label="$t('scheduleBDescription')"
                                  :rules="[fieldIsRequired()]"
                                  class="required_field"
                                  v-model="commodityInEdit.scheduleBDescription"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  :label="$t('hsCode')"
                                  :rules="[fieldIsRequired()]"
                                  :class="'required_field'"
                                  v-model="commodityInEdit.scheduleBCode"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  :rules="[
                                    fieldIsRequired(),
                                    fieldIsInteger(),
                                    fieldIsOverZero()
                                  ]"
                                  class="required_field qty_unit_filed pt-0"
                                  v-model.number="commodityInEdit.quantity"
                                  :label="$t('quantity')"
                                  :readonly="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                  :suffix="isUnitValid ? qtySuffix : ''"
                                >
                                  <template
                                    slot="append-outer"
                                    v-if="!isUnitValid"
                                  >
                                    <v-select
                                      class="qty_unit"
                                      :items="inShowChannelUnionList"
                                      v-model="commodityInEdit.selectedUnit"
                                      hide-details
                                      clearable
                                      item-text="text"
                                      item-value="key"
                                      :label="$t('unit')"
                                    ></v-select>
                                  </template>
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2> </v-flex>
                            </v-layout>
                          </template>
                        </v-card-text>
                      </v-card>

                      <template
                        v-if="(!!itn && isCreateUps) || actionFrom === 'eei'"
                      >
                        <v-card raised class="mt-3">
                          <v-card-text>
                            <v-layout row wrap mb-3>
                              <h2>EEI info</h2>
                            </v-layout>
                            <v-layout align-baseline justify-space-between>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  :label="$t('scheduleBCode')"
                                  :rules="[fieldIsRequired()]"
                                  :class="'required_field pt-0'"
                                  :disabled="!isScheduleBReady"
                                  :readonly="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                  v-model="commodityInEdit.scheduleBCode"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  :rules="[
                                    fieldIsRequired(),
                                    fieldIsInteger(),
                                    fieldIsOverZero()
                                  ]"
                                  class="required_field qty_unit_filed pt-0"
                                  v-model.number="commodityInEdit.quantity"
                                  :label="$t('quantity')"
                                  :readonly="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                  :suffix="isUnitValid ? qtySuffix : ''"
                                >
                                  <template
                                    slot="append-outer"
                                    v-if="!isUnitValid"
                                  >
                                    <v-select
                                      class="qty_unit"
                                      :items="inShowChannelUnionList"
                                      v-model="commodityInEdit.selectedUnit"
                                      hide-details
                                      clearable
                                      item-text="text"
                                      item-value="key"
                                      :label="$t('unit')"
                                    ></v-select>
                                  </template>
                                </v-text-field>
                              </v-flex>
                              <v-flex xs2>
                                <v-autocomplete
                                  hide-details
                                  v-model="
                                    commodityInEdit.exportInformationCode
                                  "
                                  :items="[
                                    {
                                      text: $t('osAllOtherExports'),
                                      value: 'OS'
                                    }
                                  ]"
                                  item-value="value"
                                  item-text="text"
                                  :rules="[fieldIsRequired()]"
                                  class="required_field"
                                  :readonly="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                  :label="$t('exportInformationCode')"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs2>
                                <v-autocomplete
                                  hide-details
                                  :items="[
                                    {
                                      text: $t('c33NoLicenseRequired'),
                                      value: 'C33'
                                    }
                                  ]"
                                  item-value="value"
                                  item-text="text"
                                  :rules="[fieldIsRequired()]"
                                  class="required_field"
                                  :readonly="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                  v-model="
                                    commodityInEdit.licenseExceptionSymbol
                                  "
                                  :label="$t('licenseExceptionSymbol')"
                                ></v-autocomplete>
                              </v-flex>
                            </v-layout>

                            <v-layout align-baseline justify-space-between>
                              <v-flex xs2>
                                <v-text-field
                                  hide-details
                                  label="ECCN"
                                  v-model="commodityInEdit.eccn"
                                  :readonly="
                                    isCommodityUnchangeable &&
                                    actionFrom === 'createLabel'
                                  "
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs2> </v-flex>
                              <v-flex xs2> </v-flex>
                              <v-flex xs2> </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </template>
                      <v-layout align-baseline justify-space-between mt-1 pl-3>
                        <v-flex xs2>
                          <v-text-field
                            hide-details
                            class="required_field"
                            :rules="[
                              fieldIsRequired(),
                              fieldIsNoLessThanZero()
                            ]"
                            v-model.number="commodityInEdit.customsValue"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                            :label="$t('totalCustomsValue($)')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-text-field
                            hide-details
                            :label="$t('totalCommodityWeight')"
                            v-model.number="commodityInEdit.commodityWeight"
                            :rules="[
                              fieldIsRequired('weight'),
                              fieldIsNoLessThanZero('weight'),
                              isMeasurementMetric
                                ? () => true
                                : fieldIsPkgWeight(false)
                            ]"
                            class="required_field"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                            :suffix="isMeasurementMetric ? 'kg' : 'Lbs'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2> </v-flex>
                        <v-flex xs2> </v-flex>
                      </v-layout>
                      <v-layout align-baseline justify-space-between>
                        <v-flex xs2>
                          <v-text-field
                            hide-details
                            :rules="[
                              fieldIsRequired(),
                              fieldIsInteger(),
                              fieldIsOverZero()
                            ]"
                            class="required_field"
                            v-model.number="commodityInEdit.quantity2"
                            :label="$t('quantity')"
                            :readonly="
                              isCommodityUnchangeable &&
                              actionFrom === 'createLabel'
                            "
                            v-if="isShowQty2"
                            :suffix="scheduleBMap[scheduleBCodeNormalized].uom1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2 style="white-space: nowrap">
                          <span v-if="!isScheduleBReady"
                            ><v-icon color="red">info</v-icon
                            >{{ $t('loadingScheduleB') }}</span
                          >
                        </v-flex>
                        <v-flex xs2> </v-flex>
                      </v-layout>
                    </v-form>
                    <v-layout justify-end align-baseline>
                      <v-flex xs2>
                        <v-text-field
                          v-if="isSaveCommodityProfile"
                          hide-details
                          v-model.trim="commodityInEdit.profileName"
                          class="required_field"
                          :rules="[fieldIsRequired()]"
                          :label="$t('profileName')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 v-if="actionType === 'add'">
                        <v-checkbox
                          :label="$t('saveCommodityProfile')"
                          hide-details
                          class="checkbox"
                          v-model="isSaveCommodityProfile"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </template>
              </template>
            </FormSubmitPopup>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { checkRules, timeTools, measurementTools } from '@/utils/tools'
import LoaderButton from './LoaderButton'
import FormSubmitPopup from './FormSubmitPopup'
import { mapGetters } from 'vuex'
export default {
  name: 'CommodityWidget',
  components: {
    LoaderButton,
    FormSubmitPopup
  },
  data () {
    return {
      commodityInEdit: {
        exportInformationCode: 'OS',
        licenseExceptionSymbol: 'C33',
        profileName: '',
        countryOfOrigin: 'US',
        scheduleBCode: '',
        customsValue: 0,
        commodityWeight: 0,
        quantity: 0,
        scheduleBDescription: '',
        selectedUnit: '',
        harmonizedCode: '',
        quantity2: 0,
        quantity2Units: ''
      },
      isSaveCommodityProfile: false,
      searchedCommodities: [],
      searchText: '',
      selectedCommodity: {},
      menuProfile: false,
      errorMessage: '',
      isShowEditCommodityPopup: false,
      actionType: '',
      commonCommodity: ''
    }
  },
  mixins: [checkRules, timeTools, measurementTools],
  beforeMount () {
    if (!this.scheduleBMap['0101210000'] && Object.keys(this.$store.getters.scheduleBMap || {}).length === 0) {
      this.$store.dispatch('getAESHTS')
    }
  },
  computed: {
    ...mapGetters(['commonCommodities']),
    countryCodeArray () {
      return this.$store.getters.countryCodeArray
    },
    isCreateFedex () {
      return this.actionFrom === 'createLabel' && this.carrier.toUpperCase().includes('FEDEX')
    },
    isCreateUps () {
      return this.actionFrom === 'createLabel' && this.carrier.toUpperCase().includes('UPS')
    },
    commodityHeaders () {
      return !this.isCommodityUnchangeable && this.actionFrom !== 'createLabel' ? [
        { text: this.$t('commodity'), value: 'name', align: 'left', sortable: false, width: '5%' },
        { text: this.actionFrom !== 'createLabel' ? this.$t('scheduleBCode') : this.$t('hsCode'), align: 'left', sortable: false },
        { text: this.$t('exportInfoCode'), value: 'exportInformationCode', align: 'left', sortable: false },
        { text: this.$t('countryOfOrigin'), value: 'countryOfOrigin', align: 'left', sortable: false },
        { text: this.$t('licenseExceptionSymbol'), value: 'licenseExceptionSymbol', align: 'left', sortable: false },
        { text: `${this.$t('customsValue')}($${this.value.reduce((acc, item) => acc + item.customsValue, 0).toLocaleString()})`, value: 'customsValue', align: 'left', sortable: false },
        { text: `${this.$t('qty')}(${this.value.reduce((acc, item) => acc + item.quantity, 0)})`, value: 'quantity', align: 'left', sortable: false },
        { text: `${this.$t('qty')}2(${this.value.reduce((acc, item) => acc + item.quantity2, 0)})`, value: 'quantity2', align: 'left', sortable: false },
        { text: `${this.$t('totalWeight')}(${this.isMeasurementMetric ? 'kg' : 'Lbs'})(${this.value.reduce((acc, item) => acc + item.commodityWeight || item.weight, 0)})`, value: 'weight', align: 'center', sortable: false, width: '8%' }
      ] : [
        { text: this.$t('commodity'), value: 'name', align: 'left', sortable: false, width: '5%' },
        { text: this.actionFrom !== 'createLabel' ? this.$t('scheduleBCode') : this.$t('hsCode'), value: 'scheduleBCode', align: 'left', sortable: false },
        { text: this.$t('exportInfoCode'), value: 'exportInformationCode', align: 'left', sortable: false },
        { text: this.$t('countryOfOrigin'), value: 'countryOfOrigin', align: 'left', sortable: false },
        { text: this.$t('licenseExceptionSymbol'), value: 'licenseExceptionSymbol', align: 'left', sortable: false },
        { text: `${this.$t('customsValue')}($${this.value.reduce((acc, item) => acc + item.customsValue, 0).toLocaleString()})`, value: 'customsValue', align: 'left', sortable: false },
        { text: `${this.$t('qty')}(${this.value.reduce((acc, item) => acc + item.quantity, 0)})`, value: 'quantity', align: 'left', sortable: false },
        { text: `${this.$t('qty')}2(${this.value.reduce((acc, item) => acc + item.quantity2, 0)})`, value: 'quantity2', align: 'left', sortable: false },
        { text: `${this.$t('totalWeight')}(${this.isMeasurementMetric ? 'kg' : 'Lbs'})(${this.value.reduce((acc, item) => acc + item.commodityWeight || item.weight, 0)})`, value: 'weight', align: 'center', sortable: false, width: '8%' },
        { text: this.$t('actions'), value: 'weight', align: 'center', sortable: false }
      ]
    },
    isMeasurementMetric () {
      return !!this.$store.getters.isMeasurementMetric
    },
    scheduleBMap () {
      return this.$store.getters.scheduleBMap
    },
    scheduleBCodeNormalized () {
      return this.commodityInEdit.scheduleBCode && this.commodityInEdit.scheduleBCode.replace('.', '')
    },
    hsCodeNormalized () {
      return this.commodityInEdit.harmonizedCode && this.commodityInEdit.harmonizedCode.replace('.', '')
    },
    isShowQty2 () {
      return this.scheduleBMap[this.scheduleBCodeNormalized] && this.scheduleBMap[this.scheduleBCodeNormalized].uom1 !== 'NULL'
    },
    hsCodeQtySuffix () {
      if (!this.scheduleBMap[this.hsCodeNormalized]) return ''
      if (this.scheduleBMap[this.hsCodeNormalized].uom1 === 'NO') {
        if (this.isEeiMode) {
          return 'NUMBER'
        }
        return this.getUnitOfMeasure(true)
      } 
      return this.scheduleBMap[this.hsCodeNormalized].uom1
    },
    qtySuffix () {
      if (!this.scheduleBMap[this.scheduleBCodeNormalized]) return ''
      if (this.scheduleBMap[this.scheduleBCodeNormalized].uom === 'NO') {
        if (this.isEeiMode) {
          return 'NUMBER'
        }
        return this.getUnitOfMeasure()
      } 
      return this.scheduleBMap[this.scheduleBCodeNormalized].uom
    },
    isScheduleBReady () {
      return !!this.scheduleBMap['0101210000']
    },
    isCommodityUnchangeable () {
      return !!this.itn && !this.itn.includes('NO EEI 30.36') && !this.itn.includes('NO EEI 30.37')
    },
    upsHsCodeUnionList () {
      return Object.entries(this.upsHsCodeUnionMap).map(([abbr, value]) => {
        return {text: value, key: abbr}
      })
    },
    upsHsCodeUnionMap () {
      return {
        'BA': 'Barrel',
        'BE': 'Bundle',
        'BG': 'Bag',
        'BH': 'Bunch',
        'BOX': 'Box',
        'BT': 'Bolt',
        'BU': 'Butt',
        'CI': 'Canister',
        'CM': 'Centimeter',
        'CON': 'Container',
        'CR': 'Crate',
        'CS': 'Case',
        'CT': 'Carton',
        'CY': 'Cylinder',
        'DOZ': 'Dozen',
        'EA': 'Each',
        'EN': 'Envelope',
        'FT': 'Feet',
        'KG': 'Kilogram',
        'KGS': 'Kilograms',
        'LB': 'Pound',
        'LBS': 'Pounds',
        'L': 'Liter',
        'M': 'Meter',
        'NMB': 'Number',
        'PA': 'Packet',
        'PAL': 'Pallet',
        'PC': 'Piece',
        'PCS': 'Pieces',
        'PF': 'Proof Liters',
        'PKG': 'Package',
        'PR': 'Pair',
        'PRS': 'Pairs',
        'RL': 'Roll',
        'SET': 'Set',
        'SME': 'Square Meters',
        'SYD': 'Square Yards',
        'TU': 'Tube',
        'YD': 'Yard'
      }
    },
    upsUnionMap () {
      return {
        'BBL': 'Barrels',
        'CAR': 'Carat',
        'CKG': 'Content Kilogram',
        'CM2': 'Square Centimeters',
        'CTN': 'Content Ton',
        'CUR': 'Curie',
        'CYK': 'Clean Yield Kilogram',
        'DOZ': 'Dozen',
        'DPC': 'Dozen Pieces',
        'DPR': 'Dozen Pairs',
        'FBM': 'Fiber Meter',
        'GCN': 'Gross Containers',
        'GM': 'Gram',
        'GRS': 'Gross',
        'HUN': 'Hundred',
        'KG': 'Kilogram',
        'KM3': '1,000 Cubic Meters',
        'KTS': 'Kilogram Total Sugars',
        'L': 'Liter',
        'M': 'Meter',
        'M2': 'Square Meters',
        'M3': 'Cubic Meters',
        'MC': 'Millicurie',
        'NO': 'Number',
        'PCS': 'Pieces',
        'PFL': 'Proof Liter',
        'PK': 'Pack',
        'PRS': 'Pairs',
        'RBA': 'Running Bales',
        'SQ': 'Square',
        'T': 'Ton',
        'THS': '1,000',
        'X': 'No Quantity required'
      }
    },
    upsUnionList () {
      return Object.entries(this.upsUnionMap).map(([abbr, value]) => {
        return {text: `${abbr}(${value})`, key: abbr}
      })
    },
    fedexUnionMap () {
      return {
        'AR': 'CARAT',
        'CM': 'CENTIMETER',
        'CFT': 'CUBIC FOOT',
        'DOZ': 'DOZEN',
        'DPR': 'DOZEN PAIR',
        'EA': 'EACH',
        'LFT': 'FOOT',
        'G': 'GRAM',
        'GR': 'GROSS',
        'KG': 'KILOGRAM',
        'LTR': 'LITER',
        'LB': 'POUND',
        'LNM': 'LINEAR METER',
        'M': 'METER',
        'M2': 'SQUARE METER (M2)',
        'M3': 'CUBIC METER',
        'MG': 'MILLIGRAM',
        'ML': 'MILLILITER',
        'NO': 'NUMBER',
        'OZ': 'OUNCE',
        'PR': 'PAIR',
        'PCS': 'PIECE',
        'SFT': 'SQUARE FOOT',
        'SYD': 'SQUARE YA,',
        'YD': 'YARD'
      }
    },
    fedexUnionList () {
      return Object.entries(this.fedexUnionMap).map(([abbr, value]) => {
        return {text: value, key: abbr}
      })
    },
    inShowChannelUnionList () {
      return this.carrier.toUpperCase().includes('UPS') ? this.upsUnionList : this.fedexUnionList
    },
    isHsCodeUnitValid () {
      if (this.actionFrom !== 'createLabel') return true
      const unit = this.hsCodeQtySuffix
      return unit && this.upsHsCodeUnionList.find(item => item.key === unit)
    },
    isUnitValid () {
      if (this.actionFrom !== 'createLabel') return true
      const unit = this.qtySuffix
      return unit && this.inShowChannelUnionList.find(item => item.key === unit)
    }
  },
  methods: {
    getUnitOfMeasure () {
      let unitOfMeasure = ''
      const matchedItem = this.scheduleBMap[this.scheduleBCodeNormalized]
      if (!matchedItem) return unitOfMeasure
      if (this.isEeiMode) return matchedItem.uom
      
      if (matchedItem.uom === 'NO') {
        const carrier = this.carrier.trim().toUpperCase()
        unitOfMeasure = (carrier.includes('UPS') && 'PCS') || (carrier.includes('FEDEX') && 'NO') || matchedItem.uom
      } else {
        unitOfMeasure = matchedItem.uom
      }
      return unitOfMeasure
    },
    getHsCodeUnitOfMeasure () {
      let unitOfMeasure = ''
      const matchedItem = this.scheduleBMap[this.scheduleBCodeNormalized]
      if (!matchedItem) return unitOfMeasure
      if (this.isEeiMode) return matchedItem.uom1
      
      if (matchedItem.uom1 === 'NULL') {
        const carrier = this.carrier.trim().toUpperCase()
        unitOfMeasure = (carrier.includes('UPS') && 'PCS') || matchedItem.uom1
      } else {
        unitOfMeasure = matchedItem.uom1
      }
      return unitOfMeasure
    },
    onSelectCommonCommodity (data) {
      Object.assign(this.commodityInEdit, {
        scheduleBDescription: data.description,
        scheduleBCode: this.isCreateFedex ? (data.hsCode || '') : data.code,
        harmonizedCode: this.isCreateFedex ? (data.hsCode || '') : data.hsCode
      })
    },
    async onSubmit () {
      switch (this.actionType) {
        case 'add':
          await this.addCommodity()
          break
        case 'edit':
          this.updateCommodity()
          break
        default:
          break
      }
    },
    onSelectCommodity (e) {
      const {createTime, lastModifiedTime, ...rest} = e
      Object.assign(this.commodityInEdit, rest, {
        commodityWeight: 0,
        customsValue: 0,
        quantity: 0,
        isMeasurementMetric: this.isMeasurementMetric
      })
      this.isSaveCommodityProfile = false
      this.menuProfile = false
    },
    convertWeight (weight, isMeasurementMetric) {
      if (!!isMeasurementMetric === !!this.isMeasurementMetric) {
        return weight
      }
      const convertFunc = this[`${isMeasurementMetric ? 'kg' : 'lbs'}_${this.$store.getters.isMeasurementMetric ? 'kg' : 'lbs'}`]
      return convertFunc(weight)
    },
    async addCommodity () {
      this.errorMessage = ''
      if (!this.$refs[`form`].validate()) return
      if (this.value.length >= 50) {
        this.errorMessage = this.$t('supportMaximumNumber')
        return
      }
      if (this.isSaveCommodityProfile && !this.commodityInEdit.profileName) {
        this.errorMessage = this.$t('profileNameIsMissing')
        return
      }
      if (this.isSaveCommodityProfile) {
        let target = await this.$store.dispatch('getCommodityKey', {keyword: this.commodityInEdit.profileName.trim(), scheduleBDescription: this.commodityInEdit.scheduleBDescription.trim()})
        const {quantity, quantity2, commodityWeight, customsValue, ...rest} = this.commodityInEdit
        if (target) {
          this.$store.dispatch('addCommodity', {...rest, isUpdate: true, key: target})
          const targetCommodityInfo = this.searchedCommodities.find(item => item.key === target)
          targetCommodityInfo && Object.assign(targetCommodityInfo, this.commodityInEdit, {isMeasurementMetric: this.isMeasurementMetric})
        } else {
          this.$store.dispatch('addCommodity', rest)
        }
        this.isSaveCommodityProfile = false
      }

      let newCommodity = {
        ...this.commodityInEdit
      }
      const matchedItem = this.scheduleBMap[this.scheduleBCodeNormalized]
      if (matchedItem) {
        if (matchedItem.uom1 !== 'NULL') {
          newCommodity.unitOfMeasure2 = matchedItem.uom1
        }
      }
      // 如果没有匹配的第一单位，默认 NO
      // 如果客户有选择第一单位，使用客户选择的第一单位
      newCommodity.unitOfMeasure = this.actionFrom === 'eei' ? (this.getUnitOfMeasure() || 'NO') : (this.isUnitValid ? this.getUnitOfMeasure() : this.commodityInEdit.selectedUnit)
      this.$emit('input', [...this.value, newCommodity])
      this.closeEditCommodityPopup()
    },
    async removeCommodityDb ({key}) {
      await this.$store.dispatch('removeCommodity', {key})
      this.searchedCommodities = this.searchedCommodities.filter(ele => ele.key !== key)
    },
    async getCommodities () {
      this.searchedCommodities = await this.$store.dispatch('getCommodities', {keyword: this.searchText})
      this.menuProfile = true
    },
    deleteCommodity (item) {
      this.$emit('input', this.value.filter(ele => ele !== item))
    },
    showCommodityEditPopup (props, type) {
      if (type === 'edit') {
        const {item, index} = props
        Object.assign(this.commodityInEdit, {...item, indexNum: index})
      }
      this.actionType = type
      this.isShowEditCommodityPopup = true
    },
    closeEditCommodityPopup () {
      this.isShowEditCommodityPopup = false
      this.$nextTick(() => {
        this.resetPopupDataInEdit()
      })
    },
    updateCommodity () {
      const {indexNum, ...rest} = this.commodityInEdit
      this.$emit('input', [...this.value].map((item, index) => {
        if (index === indexNum) {
          const matchedItem = this.scheduleBMap[this.scheduleBCodeNormalized]
          if (matchedItem) {
            if (matchedItem.uom1 !== 'NULL') {
              rest.unitOfMeasure2 = matchedItem.uom1
            }
          }
          rest.unitOfMeasure = this.actionFrom === 'eei' ? (this.getUnitOfMeasure() || 'NO') : (this.commodityInEdit.selectedUnit || this.getUnitOfMeasure())
          return rest
        }
        return item
      }))
      this.closeEditCommodityPopup()
    },
    resetPopupDataInEdit () {
      this.searchText = ''
      this.commonCommodity = ''
      this.commodityInEdit = {
        exportInformationCode: 'OS',
        licenseExceptionSymbol: 'C33',
        profileName: '',
        countryOfOrigin: 'US',
        scheduleBCode: '',
        customsValue: 0,
        commodityWeight: 0,
        quantity: 0,
        quantity2: 0,
        scheduleBDescription: ''
      }
      const $form = this.$refs[`form`]
      $form && $form.resetValidation()
    }
  },
  props: {
    value: Array,
    isEeiMode: Boolean,
    itn: {
      type: String,
      default: ''
    },
    carrier: {
      type: String,
      default: 'FEDEX'
    },
    actionFrom: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  .qty_unit_filed /deep/ .v-input__append-outer {
    margin: 0;
  }
  .qty_unit {
    margin: 0;
    padding: 0;
  }

  .qty_unit /deep/ label::after {
    content: "";
  }
</style>



// WEBPACK FOOTER //
// src/components/CommodityWidget.vue